import { createSelector } from 'reselect';
import { get } from 'lodash';
import { getChannelForWidget } from '../../common/selectors/channels';
export const getSelectedVideoIdFromStore = (state) => state.selectedVideoId;
export const getFeaturedVideoId = createSelector([getChannelForWidget], (channel) => get(channel, 'featuredItem'));
const getFirstVideoFromStore = (state) => state.firstChannelVideoId;
export const getMainVideoId = createSelector([getSelectedVideoIdFromStore, getFeaturedVideoId, getFirstVideoFromStore], (selectedVideoId, featuredVideoId, firstVideoId) => selectedVideoId || featuredVideoId || firstVideoId);
//# sourceMappingURL=selected-video-id.js.map